import {
  WSControl,
  WSInfoBox,
  WSModal,
  WSModalCustomProps,
  useWSModalCustom
} from "@wingspanhq/fe-component-library";
import React, { useState } from "react";
import { Acknowledgements } from "../Acknowledgements";

interface ModalEConsentProps extends WSModalCustomProps<void> {
  onBack: () => void;
}

const ModalEConsent: React.FC<ModalEConsentProps> = ({
  onBack,
  ...modalProps
}) => {
  const [isChecked, setIsChecked] = useState(false);

  return (
    <WSModal
      title="Consent electronic disclosures"
      size="S"
      actions={{
        alignment: "fill",
        buttons: [
          {
            label: "Back",
            onClick: () => {
              onBack();
              modalProps.onClose();
            },
            kind: "Tertiary"
          },
          {
            label: "Continue",
            onClick: () => {
              if (isChecked) {
                modalProps.onClose();
              }
            },
            kind: "Primary",
            disabled: !isChecked
          }
        ]
      }}
      {...modalProps}
    >
      <WSInfoBox mb="XL">
        <Acknowledgements
          aknowledgements={["ElectronicDisclosureAndConsent"]}
        />
      </WSInfoBox>

      <WSControl
        type="checkbox"
        value={isChecked}
        onChange={setIsChecked}
        label="I have read, and agree to the Electronic Disclosure and Consent documents and their contents."
        size="S"
      />
    </WSModal>
  );
};

export const useModalEConsent = () => useWSModalCustom(ModalEConsent);
